import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractTextInput} from "../abstract-text-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIInlineTextInputComponent),
            multi: true
        }
    ],
    selector: "fui-inline-text-input",
    styleUrls: ["./inline-text-input.component.scss"],
    templateUrl: "./inline-text-input.component.html",
    standalone: false
})
export class FUIInlineTextInputComponent extends FUIAbstractTextInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }
}
